<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="100"
      ref="FormComponent"
      @handleReset="handleReset"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem label="" :label-width="0">
          <RadioGroup
            v-model="formItem.achStage"
            style="display:flex;justify-content: space-between"
            @on-change="achStageChange"
          >
            <Radio label="目标设定"
              ><!-- 目标设定 -->{{ $t("Objective_Setting") }}</Radio
            >
            <Radio label="阶段回顾"
              ><!-- 阶段回顾 -->{{ $t("Phase_Review") }}</Radio
            >
            <Radio label="年终总结"
              ><!-- 年终总结 -->{{ $t("End-Year_Review_Over") }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot2">
        <FormItem :label="$t('Competencies')"
          ><!-- 能力项 -->
          <Input v-model="formItem.ability" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot3">
        <FormItem :label="$t('Development_Objectives')"
          ><!-- 发展目标 -->
          <Input v-model="formItem.developTarget" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot4">
        <FormItem :label="$t('Start_Date')"
          ><!-- 开始日期 -->
          <DatePicker
            type="daterange"
            :transfer="true"
            v-model="formItem.beginDate"
            style="width:100%"
            clearable
            @on-change="formItem.beginDate = $event"
          ></DatePicker>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot5">
        <FormItem :label="$t('End_Date')"
          ><!-- 结束日期 -->
          <DatePicker
            type="daterange"
            :transfer="true"
            v-model="formItem.afterDate"
            style="width:100%"
            clearable
            @on-change="formItem.afterDate = $event"
          ></DatePicker>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="24" :lg="6" slot="slot6">
        <FormItem :label="$t('Detailed_Description')"
          ><!-- 详细描述 -->
          <Input v-model="formItem.details" clearable />
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot7"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
    </FormComponent>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin:20px 0"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <Table
      border
      :loading="loading"
      :columns="columnsA"
      :data="dataA"
      style="margin:20px 0"
      ref="tableRef"
      v-show="false"
    ></Table>
    <div
      style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <Button type="primary" style="margin-top:15px" @click="exportData()"
        ><!-- 导出 -->{{ $t("PB_Export") }}</Button
      >
    </div>
  </div>
</template>

<script>
import FormComponent from "./FormComponent.vue";
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
export default {
  components: { FormComponent },
  data() {
    return {
      date: new DateUtil(),
      prevent: false,
      formItem: {
        achStage: "目标设定"
      },
      searchItem: {
        achStage: "目标设定"
      },
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data: [],
      dataA: [],
      columns: [],
      columnsA: [],
      ManagementLevel: []
    };
  },
  computed: {
    columnsa() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 80,
          fixed: "left"
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 80
        },
        {
          title: this.$t("Competencies") /* 能力项 */,
          key: "ability",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Development_Objectives") /* 发展目标 */,
          key: "developTarget",
          align: "center",
          minWidth: 300
        },
        {
          title: this.$t("longText12") /* 详细描述(10-20-70的行动计划) */,
          key: "details",
          align: "center",
          minWidth: 350
        },
        {
          title: this.$t("Start_Date") /* 开始日期 */,
          key: "startDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("End_Date") /* 结束日期 */,
          key: "endDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.endDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("Employee_Comment") /* 员工说明 */,
          key: "empDetails",
          align: "center",
          minWidth: 200,
          hidden: true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          key: "dirSupFeedback",
          align: "center",
          minWidth: 200,
          hidden: true
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 直线上级反馈 */,
          key: "indirSupFeedback",
          align: "center",
          minWidth: 200,
          hidden: true
        }
      ];
    },
    columnsb() {
      return [
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Competencies") /* 能力项 */,
          key: "ability",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Development_Objectives") /* 发展目标 */,
          key: "developTarget",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("longText12") /* 详细描述(10-20-70的行动计划) */,
          key: "details",
          align: "center",
          minWidth: 280
        },
        {
          title: this.$t("Start_Date") /* 开始日期 */,
          key: "startDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("End_Date") /* 结束日期 */,
          key: "endDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.endDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("Employee_Comment") /* 员工说明 */,
          key: "empDetails",
          align: "center",
          minWidth: 120,
          hidden: true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          key: "dirSupFeedback",
          align: "center",
          minWidth: 120,
          hidden: true
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 直线上级反馈 */,
          key: "indirSupFeedback",
          align: "center",
          minWidth: 120,
          hidden: true
        }
      ];
    }
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (this.formItem.achStage == "目标设定") {
        this.columns = this.columnsa.filter(function(e) {
          return !e.hidden;
        });
        this.columnsA = this.columnsb.filter(function(e) {
          return !e.hidden;
        });
      } else {
        this.columns = this.columnsa;
        this.columnsA = this.columnsb;
      }
    }
  },

  mounted() {
    // this.getData()
    this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
    // this.getListData()
    this.columns = this.columnsa.filter(function(e) {
      return !e.hidden;
    });
    this.columnsA = this.columnsb.filter(function(e) {
      return !e.hidden;
    });
  },
  methods: {
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.$refs.FormComponent.functionList = res.functionList;
          this.ManagementLevel = res.ManagementLevel;
        }
      });
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      // this.searchItem.startDate?this.searchItem.startDate=this.date.dateVal(this.searchItem.startDate,'YYYY-MM-DD'):''
      // this.searchItem.endDate?this.searchItem.endDate=this.date.dateVal(this.searchItem.endDate,'YYYY-MM-DD'):''
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        ...this.pageInfo
      };
      this.loading = true;
      axios.post("/achReport/selectDevelopmentPlanInfo", obj).then(res => {
        if (res) {
          this.data = res.data;
          this.total = parseInt(res.pageInfo.total);
        }
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
      });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },

    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    exportData() {
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        pageNo: 1,
        pageSize: 99999
      };
      this.loading = true;
      axios.post("/achReport/selectDevelopmentPlanInfo", obj).then(res => {
        if (res) {
          res.data.forEach(item => {
            item.startDate = this.date.dateVal(item.startDate, "YYYY-MM-DD");
            item.endDate = this.date.dateVal(item.endDate, "YYYY-MM-DD");
          });
          this.$nextTick(() => {
            this.$exportExcel(
              "tableRef",
              this.$t("Development_Plans") +
                this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
              res.data
            );
          });
        }
        this.loading = false;
      });

      // this.$refs.table.exportCsv({
      //     filename: '个人发展计划'
      // });
    },
    checkBtn(row, index) {
      const href =
        "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
        row.id +
        "&serialnumber=" +
        row.serialnumber +
        "&year=" +
        row.year +
        "&userName=" +
        row.userName +
        "&returnFlag='1'";
      window.open(href, "_blank");
      // this.$router.push({
      //     path: '/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27',
      //     query: { id: row.id ,serialnumber:row.serialnumber,year:row.year}
      // })
    },
    handleReset() {
      if (this.formItem.achStage == "目标设定") {
        this.formItem = {
          achStage: "目标设定"
        };
      } else if (this.formItem.achStage == "阶段回顾") {
        this.formItem = {
          achStage: "阶段回顾"
        };
      } else {
        this.formItem = {
          achStage: "年终总结"
        };
        this.formItem.achStage = "年终总结";
      }

      this.serialnumber.year = this.date.dateVal(new Date(), "YYYY");
      // this.pageInfo.pageNo=1
      // this.getData(JSON.stringify(this.formItem))
    },
    achStageChange(val) {
      if (val == "目标设定") {
        this.columns = this.columnsa.filter(function(e) {
          return !e.hidden;
        });
        this.columnsA = this.columnsb.filter(function(e) {
          return !e.hidden;
        });
      } else {
        this.columns = this.columnsa;
        this.columnsA = this.columnsb;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PersonalDevelopmentPlan.vue